import { render, staticRenderFns } from "./Notices.vue?vue&type=template&id=4825fc1b&scoped=true&"
import script from "./Notices.vue?vue&type=script&lang=js&"
export * from "./Notices.vue?vue&type=script&lang=js&"
import style0 from "./Notices.vue?vue&type=style&index=0&id=4825fc1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4825fc1b",
  null
  
)

export default component.exports